export const FETCH_SENT_COUPONS = "FETCH_SENT_COUPONS";
export const ADD_SENT_COUPON = "ADD_SENT_COUPON";
export const DELETE_SENT_COUPON = "DELETE_SENT_COUPON";
export const UPDATE_SENT_COUPON = "UPDATE_SENT_COUPON";

export const FETCH_RECEIVED_COUPONS = "FETCH_RECEIVED_COUPONS";
export const ADD_RECEIVED_COUPON = "ADD_RECEIVED_COUPON";
export const DELETE_RECEIVED_COUPON = "DELETE_RECEIVED_COUPON";
export const UPDATE_RECEIVED_COUPON = "UPDATE_RECEIVED_COUPON";
